import React from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';

const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table-striped table-admin" />
);

export default TableComponent;
